import React from 'react';
import styled from 'styled-components';
import defaults from '../translations/en.json';
const DescriptionDiv = styled.div.withConfig({
  displayName: "ReportDescription__DescriptionDiv",
  componentId: "r0nv1n-0"
})(["min-height:1.5em;"]);
export const ReportDescription = ({
  reportHeader
}) => /*#__PURE__*/React.createElement(DescriptionDiv, null, `${defaults.reportDescription}: ${reportHeader === null || reportHeader === void 0 ? void 0 : reportHeader.description}`);